import classNames from "classnames";
import PieChart from "./PieChart";
import { useState } from "react";
import { ProgressBar } from "antd-mobile";
import BarChart from "./BarChart";
import Pollutants from "./Content/Pollutants";
import QualityScale from "./Content/QualityScale";
import { pxChangeVw } from "@/utils";

interface DateInfo {
  month: number;
  day: number;
  dayOfWeek: number;
}

function getDayOfWeekName(dayOfWeek: number): string {
  const days = ["Sunday", "Monday", "Tuesday", "Wednesday", "Thursday", "Friday", "Saturday"];
  return days[dayOfWeek];
}

function getNextFiveDays(): DateInfo[] {
  const dates: DateInfo[] = [];
  for (let i = 0; i < 5; i++) {
    const date = new Date();
    date.setDate(date.getDate() + i);
    const day = date.getDay();
    const month = date.getMonth() + 1;
    const dayOfMonth = date.getDate();
    dates.push({
      month,
      day: dayOfMonth,
      dayOfWeek: day,
    });
  }
  return dates;
}

const WeatherInfo: React.FC<{ item: DateInfo }> = ({}) => (
  <div className="flex flex-col items-center gap-y-16">
    <div>
      <PieChart />
    </div>
    <div>Fair</div>
    <div className="text-12 text-center bg-[transparent]">
      The air quality is generally acceptable for most individuals. However, sensitive groups may experience minor to
      moderate symptoms from long-term exposure.
    </div>
  </div>
);

const AirQualityDefault: React.FC = () => {
  const [activeIndex, setActiveIndex] = useState(0);

  const handleClick = (index: number) => () => setActiveIndex(index);

  const datesInfo = getNextFiveDays();

  return (
    <div className="flex flex-col justify-start gap-y-10 p-[0_16px] box-border">
      <WeatherMainContent className="content">
        <div className="text-12">
          <div className="lh-16">CURRENT AIR QUALITY</div>
          <div className="flex flex-row justify-end">
            <div className="text-center">
              <div className="font-200">SUNDAY</div>
              <div className="font-200">28/04</div>
            </div>
          </div>
          <WeatherInfo item={datesInfo[0]} />
        </div>
      </WeatherMainContent>

      <WeatherMainContent className="content">
        <div>
          <div className="flex flex-row items-start text-12 gap-x-28 color-[rgba(255,255,255,0.7)] mb-16">
            <div
              onClick={handleClick(0)}
              className={classNames("border-b-2 border-b-solid border-b-[#fff] pb-8 color-[#fff]", {
                "border-b-2 border-b-solid border-b-[#fff] pb-8 color-[#fff]": activeIndex === 0,
              })}
            >
              Current Pollutants
            </div>
            <div
              onClick={handleClick(1)}
              className={classNames("border-b-2 border-b-solid border-b-[#fff] pb-8 color-[#fff]", {
                "border-b-2 border-b-solid border-b-[#fff] pb-8 color-[#fff]": activeIndex === 1,
              })}
            >
              Air Quality Scale
            </div>
          </div>
          <div>{activeIndex === 0 ? <Pollutants /> : <QualityScale />}</div>
        </div>
      </WeatherMainContent>

      <WeatherMainContent
        className="content"
        style={{
          position: "relative",
          paddingBottom: pxChangeVw("45px"),
        }}
      >
        <div className="flex flex-col gap-y-13">
          <div className="text-12 lh-17">YORK HILL ESTATE CUR</div>
          <div>
            <WeatherImage className="w-full" src="https://www.w3school.com.cn/i/photo/life.png" prefix={false} />
          </div>
        </div>
        <div className="bg-[#1272b3] h-45 w-full absolute bottom-0 left-0 rounded-[0_0_10px_10px] flex justify-start items-center p-[0_10px] gap-x-8">
          <div>Excellent</div>
          <ProgressBar
            percent={100}
            style={{
              width: "68%",
              "--fill-color": "linear-gradient(to right, #38D3FF,#C4FF89,#FFFD29,#FFD629,#FF628A,#D662FD,#7A28FF)",
            }}
          />
          <div>Dangerous</div>
        </div>
      </WeatherMainContent>

      <WeatherMainContent
        className="content"
        style={{
          position: "relative",
          paddingBottom: pxChangeVw("45px"),
        }}
      >
        <div className="flex flex-col gap-y-13">
          <div className="text-12 lh-17">24-hour air quality forecast</div>
          <div>
            <BarChart />
          </div>
          <div></div>
        </div>
      </WeatherMainContent>

      <WeatherMainContent className="content flex flex-col gap-y-16">
        {datesInfo.map((item, index) => (
          <div
            key={index}
            className="text-12"
            style={{
              borderBottom: "1px solid rgba(255,255,255,0.15)",
              paddingBottom: pxChangeVw("16px"),
            }}
          >
            {index === 0 && <div className="lh-16">DAILY FORECAST</div>}
            <div className="flex flex-row justify-end">
              <div className="text-center">
                <div className="font-200">{getDayOfWeekName(item.dayOfWeek)}</div>
                <div className="font-200">
                  {item.month}/{item.day}
                </div>
              </div>
            </div>
            <WeatherInfo item={item} />
          </div>
        ))}
      </WeatherMainContent>
    </div>
  );
};

export default AirQualityDefault;
